import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultEmptyState = () => /*#__PURE__*/_jsx(UIEmptyState, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.emptyStates.default.title"
  }),
  primaryContent: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.emptyStates.default.message"
  }),
  secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
    name: "all-conversations-complete",
    height: "100%"
  }),
  "data-selenium-test": "tasks-table-empty-state"
});
export default DefaultEmptyState;